var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorse2Female(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 100,
    viewBox: "0 0 90 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8240_8362)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8240_8362)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8240_8362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5172 73.8177C43.5172 73.8177 44.833 74.5368 46.2712 74.4144C47.7094 74.292 49.3771 73.6953 49.3771 73.6953C49.3771 73.6953 54.9769 63.3525 61.1275 57.0948C68.2114 49.8885 72.8855 49.5363 72.8855 49.5363L71.3555 41.1213C71.3555 41.1213 75.2953 42.8352 57.5779 47.8995C47.8012 50.6994 39.7075 49.4295 35.5612 48.3738C26.7025 46.1247 21.9365 44.0589 18.5705 41.1213C18.1574 42.789 18.2033 44.0283 17.8055 45.7113C17.4077 47.3943 17.0405 51.0663 17.0405 51.0663C17.0405 51.0663 29.6401 57.0948 31.981 59.4816C38.254 65.8923 43.5325 73.8024 43.5325 73.8024L43.5172 73.8177Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.046 15.0264C23.046 15.0264 30.5583 12.4645 42.9972 11.8984C55.4361 11.3323 63.4331 13.5264 63.4331 13.5264L62.9331 8.02637C62.9331 8.02637 66.551 2.02637 66.4331 -2.47363C66.3413 -5.97733 64.7538 -9.8429 64.4631 -14.2187C64.1877 -18.5945 64.5396 -26.2445 64.5396 -26.2445L60.3933 -27.1166C60.3933 -27.1166 57.8076 -15.2591 45.1698 -15.7334C32.532 -16.2077 29.5638 -22.1747 29.013 -27.698L23.9334 -26.2445C23.9334 -26.2445 25.2798 -20.8742 23.7192 -15.0755C23.7192 -15.0755 21.0111 -7.2419 20.9499 -0.112099C20.9193 2.7184 21.9329 5.52637 22.9329 7.52637L23.046 15.0264Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.582 100.026C19.1732 89.4685 18.0143 82.3584 17.4234 75.8613C16.9349 70.4522 17.2531 66.5903 17.1963 64.7208C17.0372 59.2657 16.8668 54.4235 17.4235 48.2329C17.7757 44.3407 18.2757 43.1761 18.6961 40.9389C18.7074 38.0428 19.196 35.9741 19.605 34.641C20.2413 32.603 20.8549 30.1512 21.957 27.439C23.4741 20.5334 23.3486 15.9124 22.7182 7.35034C22.5364 6.89064 22.1046 5.86397 21.7183 4.31631C21.4456 3.24367 21.2411 1.9565 21.1048 0.0870455C20.9116 -2.41067 20.6389 -5.72052 20.1844 -10.1337",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2109 98.986C43.7158 92.8966 44.8327 88.0771 44.5879 81.0238C44.4961 78.5452 44.8174 76.5868 44.6338 74.2459C45.0775 74.4601 44.4808 74.3071 45.4753 74.3683C46.5463 74.4295 47.1736 74.1847 47.6326 74.0011C47.6785 78.1015 47.5102 80.4118 47.5867 84.5428C47.6632 89.3317 47.755 94.1053 47.8621 98.8636",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5734 98.4963C70.2166 96.1617 71.0695 92.8199 71.8665 88.7457C73.5303 80.1396 73.1599 74.4786 73.5094 67.4899C73.8869 59.8756 73.4324 56.6254 73.0409 51.9255C72.6355 47.0121 71.9364 43.2126 71.2932 39.291C70.8597 36.6511 70.3144 34.0571 69.5734 32.3938C66.2317 24.8253 64.8405 23.3604 63.7219 16.3717C63.0928 12.4043 62.5823 9.52014 63.2675 7.2923C64.0924 6.04105 65.225 3.99632 65.8681 1.23441C66.3295 -0.703499 66.4134 -2.41253 66.3855 -3.6943C66.2596 -4.35044 66.1478 -5.43384 66.3855 -6.73087C66.6931 -8.40938 67.4341 -9.56908 67.8676 -10.1337",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3125 37.5716C44.3125 36.5006 44.8939 35.6438 45.613 35.6438C46.3321 35.6438 46.9135 36.5006 46.9135 37.5716",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9326 7.52637C22.9326 7.52637 24.1626 9.40453 27.7887 10.093",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4326 7.02637C63.4326 7.02637 61.2625 10.0558 56.9326 9.84157",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.8612 72.7181C82.8191 63.6973 84.3755 41.3826 74.9378 24.2906",
    stroke: "#2E2E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.6 6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1811 23.8572C10.5035 32.7798 2.25549 54.8515 6.68468 71.7574",
    stroke: "#2E2E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.6 6.6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8240_8362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8240_8362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8240_8362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.3235,
    height: 152.924,
    fill: "white",
    transform: "translate(13.4351 -51.9736)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorse2Female);
export default __webpack_public_path__ + "static/media/torse-2-female.d59f65a2d3b7cbcfa33bb48ea1ad63c3.svg";
export { ForwardRef as ReactComponent };